// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dc7Z","largestCol":"styles_largestCol__4OD4n","smallestCol":"styles_smallestCol__-NIP_"};